import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskCatalogItem, ToolCatalogItem } from "../../../shared/types";

export function useTaskCatalog(brandId: string | undefined) {
  return useQuery({
    queryKey: ["task-catalog", brandId],
    queryFn: () =>
      api.get<{ data: TaskCatalogItem[] }>(`/api/brands/${encodeURIComponent(brandId!)}/task-catalog`),
    enabled: !!brandId,
  });
}

export function useToolCatalog() {
  return useQuery({
    queryKey: ["tool-catalog"],
    queryFn: () => api.get<{ data: ToolCatalogItem[] }>("/api/task-tools"),
  });
}
